import { withGTM } from '@/features/shared/HOCs';
import React, { memo, useMemo } from 'react';

import { Column } from './Column';
import { onDatalayer } from './FeaturedContent.datalayer';
import { FeaturedContentProps } from './FeaturedContent.interface';
import { Grid } from './Grid';
import { RowType } from './RowType';

const GridGTM = withGTM({ Component: Grid, onDatalayer });
const ColumnGTM = withGTM({ Component: Column, onDatalayer });
const RowTypeGTM = withGTM({ Component: RowType, onDatalayer });

const mapTemplateToComponent = (template: string) => {
  if (/grid$/i.test(template)) {
    return GridGTM;
  }

  if (/column$/i.test(template)) {
    return ColumnGTM;
  }

  return RowTypeGTM;
};

const FeaturedContent = ({
  template,
  curatedList,
  theme,
  contentButtons,
  cardColor,
  isCardImages = false,
  presentation,
  cardTheme,
  showCaption = true,
}: Br.PropsWithContentButtons<FeaturedContentProps>) => {
  const Variant = useMemo(() => mapTemplateToComponent(template || ''), [template]);

  return (
    <Variant
      curatedList={curatedList}
      theme={theme}
      contentButtons={contentButtons}
      presentation={presentation}
      cardColor={cardColor}
      cardTheme={cardTheme}
      isCardImages={isCardImages}
      showCaption={showCaption}
      template={template}
    />
  );
};

export default memo(FeaturedContent);
